<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M28.91 36.64L36.94 32l-8.03-4.64v9.28z"/><path d="M53 9H11a2 2 0 00-2 2v42a2 2 0 002 2h42a2 2 0 002-2V11a2 2 0 00-2-2zm-6.18 30.45a3.88 3.88 0 01-2.74 2.73c-2.41.65-12.08.65-12.08.65s-9.67 0-12.08-.65a3.88 3.88 0 01-2.74-2.73 40.67 40.67 0 01-.64-7.45 40.59 40.59 0 01.64-7.44 3.88 3.88 0 012.74-2.73c2.41-.65 12.08-.65 12.08-.65s9.67 0 12.08.65a3.88 3.88 0 012.74 2.73 40.59 40.59 0 01.64 7.44 40.67 40.67 0 01-.64 7.45z"/></svg>